import 'slick-carousel'
import GET_ARTICLES from '../plugins/getArticles'

const [ w, d, mq ] = [ window, document, window.matchMedia( "(max-width: 900px)" ) ]

const slider = {
  obj:'[data-plugin="slider"]',
  init() {
    $(this.obj).slick({
      autoplay:true,
      fade: true,
      dots: true,
      speed: 1200,
      autoplaySpeed: 4000,
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: false
    })
  }
}

const init = () => {

  // slick実行
  w.load['mainvisual'].then( () => slider.init() )

  //ticker
  $.when( w.load['block-ticker'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="link">
        <span class="cat">${item.category.name}</span>
        <span class="date">${item.date}</span>
        <span class="subject">${item.title}</span>
      </a>
    `)[0]
    GET_ARTICLES( '.ticker__article[data-plugin="getArticles"]', { makeItem })
  })

  // works
  $.when( w.load['block-works'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="works-item">
        <figure class="works-item__img">
          <div class="works-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="300" loading="lazy"></div>
        </figure>
        <div class="works-item__body">
          <span class="cate">${item.category.name}</span>
          <h4 class="subject">
            ${item.title}${item.is_new ? '<span class="new">NEW</span>': ''}
          </h4>
        </div>
      </a>
    `)[0]
    GET_ARTICLES('.block-works__list[data-plugin="getArticles"]',{ makeItem })
  })

  // news
  $.when( w.load['block-news'] ).then( () => {
    let makeItem = item => $(`
      <li class="block-news-item">
        <a href="${item.href}">
          <span class="cate">${item.category.name}</span>
          <span class="date">${item.date}</span>
          <span class="subject">${item.title.str_truncate(24)}</span>
        </a>
      </li>
    `)[0]
    GET_ARTICLES('.block-news__list[data-plugin="getArticles"]', { makeItem })
  })

}

export default function HOME() {

  $(() => init() )

}